<template>

<core-panel>

	<template v-slot:head>

		<h1>Play Variety</h1>

		<p>The variety of games played with you.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in list" :key="index" :subtext="item.games + ' game' + ((item.games > 1) ? 's' : '') + ' in ' + item.plays + ' play' + ((item.plays > 1) ? 's' : '')" />
	
    </template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'plays',
			list: []
		}

	},

	methods: {

		response: function(json) {

			this.list = json.plays.list

		}

	}

}

</script>